import React, { useMemo, useState } from 'react'
import RenewMotorLayout from '../../../../motorInsurancePages/renewalMotorPolicy/renewMotorLayout'
import TitleDescription from '../../../../../components/newMotorPolicy/titleDescription/titleDescription';
import AlertComponent from '../../../../motorInsurancePages/transferPolicyFlow/alertComponent';
import Input from '../../../../../components/common/Input/Input';
import FileUpload from '../../../../../components/common/fileUploadInput/fileUploadInput';
import redflag from "../../../../../assets/images/bahrainsmlogo.svg"
import useValidation from '../../../../../hooks/useValidation';
import { WITHDRAWAL_VALIDATION_CONFIG } from './data';
import useLanguageTranslate from '../../../../../hooks/useLanguageTranslate';
import { useTranslation } from 'react-i18next';
import useLifePolicyDetails from '../../../../../hooks/life/useLifePolicyDetails';
import { currencyFormatterWithCountryCode, decodeQueryString, decryptPolicyNumber } from '../../../../../utils';
import useCreateLifeRequests  from '../../../../../hooks/life/useCreateLifeRequests';
import useScreenResolution from '../../../../../hooks/useScreenResolution';
import { toast } from 'sonner';


const ChangeExistingFunds = ({ switchToggle , formData,setFormData }) => {

    const { errors, validateFields } = useValidation();
    const translate = useLanguageTranslate()
    const { t } = useTranslation()
    const params = decodeQueryString()
    const { data, isLoading } = useLifePolicyDetails(decryptPolicyNumber(params?.policy));
    const {mobile} = useScreenResolution()
 
    const productCode = data?.PolicyDetails?.ProductCode;
    const isUSDPlan = ["ROEDU", "ROFUTURE", "ROFUTPA", "FLEXSPL"].includes(productCode);
    const isSVPRO = productCode === "SVPRO";
    const minWithdrawal = isUSDPlan ? 1000 : (isSVPRO ? 188 : 376);
    const minRemaining = isUSDPlan ? 1000 : 376;
    const currencyLabel = isUSDPlan ? translate("USD", "دولار أمريكي") : translate("BHD", "دينار بحريني");

    const validationCheck = (values) => {
        const config = (isUSDPlan || isSVPRO)
            ? WITHDRAWAL_VALIDATION_CONFIG.map(field =>
                field.name === "amount" ? { ...field, validations: ["required", "min"], min_value: minWithdrawal } : field
              )
            : WITHDRAWAL_VALIDATION_CONFIG;
        let isValid = validateFields(config, values || formData);
        return isValid
    }
    // const onFileUploaded = (value, name) => {
    //     let update = { ...formData, [name]: value };
    //     if (errors?.[name]) {
    //         validationCheck(update);
    //     }
    //     setFormData(update);
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let update = { ...formData, [name]: value }
        if (errors?.[name]) {
            validationCheck(update);
        }
        setFormData(update);
    };
    const currentEncashment = useMemo(() => {
        let currentValue = data?.LifeDetails?.policyList?.[0]?.currentValue;
        return currentValue?.length > 4 ? currentValue?.slice(4, currentValue?.length) : currentValue;
    }, [data])

    const maxWithdrawal = useMemo(() => {
        let val = parseFloat(currentEncashment) || 0;
        return val * 0.5;
    }, [currentEncashment])

    const continueClickHanlder = async () => {
        let isValid = validationCheck();
        if (!isValid) return;
        if (isUSDPlan) {
            const amount = parseFloat(formData?.amount) || 0;
            if (amount > maxWithdrawal) {
                toast.error(translate("Maximum gross withdrawal amount allowed is 50% of current value", "الحد الأقصى لمبلغ السحب الإجمالي المسموح به هو 50% من القيمة الحالية"));
                return;
            }
            const remaining = parseFloat(currentEncashment) - amount;
            if (remaining < minRemaining) {
                toast.error(translate("At least USD 1,000 must remain in the account", "يجب أن يبقى على الأقل 1,000 دولار أمريكي في الحساب"));
                return;
            }
        }
        if (isSVPRO) {
            const amount = parseFloat(formData?.amount) || 0;
            const max85 = (parseFloat(currentEncashment) || 0) * 0.85;
            if (amount > max85) {
                toast.error(translate("Maximum withdrawal amount is up to 85% of the plan value", "الحد الأقصى لمبلغ السحب يصل إلى 85% من قيمة البرنامج"));
                return;
            }
        }
        switchToggle();
    };

    console.log(data,'some data')
    return (
      <RenewMotorLayout is_hide_back_btn btn_onClick={continueClickHanlder} show_close_btn={mobile}>
        <div className="changeplatenumber w-[500px] max-w-[100%] mx-auto bg-white max767:p-5">
          <TitleDescription
            title={t("lifeInsurance.withdrawal.changeExistingFunds.title")}
          />
          <AlertComponent
            title={translate(
              "Please note, this request will be submitted for approval before it takes effects",
              "يرجى ملاحظة أن هذا الطلب سيتم تقديمه للموافقة عليه قبل أن يصبح ساري المفعول"
            )}
          />
          {["ROFUTURE", "ROFUTPA"].includes(data?.PolicyDetails?.ProductCode) && (
            <div className="mt-3 p-4 bg-[#FFF8E1] rounded-lg text-[#1A2024] text-sm leading-6">
              <p className="font-semibold">{translate("No Partial Withdrawal can be made until 36 months have passed and contributions paid.", "لا يمكن إجراء أي سحب جزئي من البرنامج إلا بعد مرور 36 شهرًا وسداد كامل المبلغ.")}</p>
              <p className="mt-1 text-xs text-[#5B6871]">{translate("*Terms & Conditions apply", "*تُطبق الشروط والأحكام")}</p>
            </div>
          )}
          {data?.PolicyDetails?.ProductCode === "ROEDU" && (
            <div className="mt-3 p-4 bg-[#FFF8E1] rounded-lg text-[#1A2024] text-sm leading-6">
              <p className="font-semibold">{translate("No Partial Withdrawal can be made until 24 months have passed and contributions paid.", "لا يمكن إجراء أي سحب جزئي من البرنامج إلا بعد مرور 24 شهرًا وسداد كامل المبلغ.")}</p>
              <p className="mt-1 text-xs text-[#5B6871]">{translate("*Terms & Conditions apply", "*تُطبق الشروط والأحكام")}</p>
            </div>
          )}
          {["ROEDU", "ROFUTURE", "ROFUTPA", "FLEXSPL"].includes(data?.PolicyDetails?.ProductCode) && (
            <div className="mt-3 p-4 bg-[#FFF8E1] rounded-lg text-[#1A2024] text-sm leading-6">
              <p className="font-semibold">{translate("Partial Withdrawal Charges is USD 25", "رسوم السحب الجزئي 25 دولار أمريكي")}</p>
            </div>
          )}
          <div className="currentEncashment mt-4">
            <p className="text-[#1A2024] text-base not-italic font-medium leading-[26px] tracking-[-0.16px]">
              {t(
                "lifeInsurance.withdrawal.changeExistingFunds.currentEnhanceLabel"
              )}
            </p>
            <div className="bg-[#F6F8F9] rounded-[10px] flex justify-between p-3 max767:h-[77px] max767:items-center h-[77px] items-center">
              <p className="font-extrabold">
                {currencyFormatterWithCountryCode(currentEncashment)}
              </p>
              <div className="flex  align-middle">
                {!isUSDPlan && <img src={redflag} alt="flag" />}
                <p className="ml-2 text-black text-lg not-italic font-normal leading-[26px] tracking-[-0.18px]">
                  {currencyLabel}
                </p>
              </div>
            </div>
            {!isUSDPlan && <small className="text-[#48535B] text-xs not-italic font-normal leading-[26px] tracking-[-0.12px] mt-2 mb-4 flex">
              {t(
                "lifeInsurance.withdrawal.changeExistingFunds.currentEnhanceHintLabel"
              )}
            </small>}
          </div>
          <div className="newprimium">
            <Input
              label={t(
                "lifeInsurance.withdrawal.changeExistingFunds.withdrawalAmountLabel"
              )}
              endAdornment={
                <div className="flex align-middle mt-1">
                  {!isUSDPlan && <img src={redflag} alt="flag" />}
                  <p className="ml-2 text-black text-lg not-italic font-normal leading-[26px] tracking-[-0.18px]">
                    {currencyLabel}
                  </p>
                </div>
              }
              type="number"
              name="amount"
              setFormData={setFormData}
              value={formData.amount}
              handleChange={handleChange}
              error={errors.amount}
              hint_msg={isUSDPlan ? translate("Minimum net withdrawal amount allowed is USD 1,000. Maximum gross withdrawal amount allowed is 50% of current value subject to at least USD 1,000 remaining in the account.", "الحد الأدنى لصافي مبلغ السحب المسموح به هو 1,000 دولار أمريكي. الحد الأقصى لمبلغ السحب الإجمالي هو 50% من القيمة الحالية بشرط بقاء 1,000 دولار أمريكي على الأقل في الحساب.") : undefined}
            />
          </div>
          <div className="IBAN mt-4 w-full">
            <Input
              label={t(
                "lifeInsurance.withdrawal.changeExistingFunds.ibanNumberLabel"
              )}
              name="iban_number"
              setFormData={setFormData}
              value={formData.iban_number}
              handleChange={handleChange}
              error={errors.iban_number}
            />
          </div>
          {/* <div className="flex flex-col ">
                    <p className='text-[#48535B] text-base not-italic font-normal leading-[26px] tracking-[-0.16px]'>
                    {t("lifeInsurance.withdrawal.changeExistingFunds.uploadPhotosOfCarLabel")}
                    </p>
                    <FileUpload
                        name="iban_certificate"
                        toggleFileUpload={onFileUploaded}
                    />
                    {errors?.iban_certificate && (
                        <p className="field-err text-red-500 text-sm mt-1 text-left">{errors?.iban_certificate}</p>
                    )}
                </div> */}
        </div>
      </RenewMotorLayout>
    );
}

export default ChangeExistingFunds